export var Length;
(function (Length) {
    Length["EXTRA_SHORT"] = "extraShort";
    Length["SHORT"] = "short";
    Length["MEDIUM"] = "medium";
    Length["LONG"] = "long";
    Length["EXTRA_LONG"] = "extraLong";
})(Length || (Length = {}));
export var Height;
(function (Height) {
    Height["EXTRA_SMALL"] = "extraSmall";
    Height["SMALL"] = "small";
    Height["MEDIUM"] = "medium";
    Height["LARGE"] = "large";
})(Height || (Height = {}));
export const LengthForSkeletonOpacity = 10;
